<template>
  <div class="fillcontain">
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        align="center"
        @select="selectTable"
        @select-all="selectAll"
        @selection-change="handleSelectionChange"
        @expand-change="toggleRowData"
        :row-key="getRowKeys"
        :expand-row-keys="expands"
      >
    <el-table-column type="expand">
       <template slot-scope="scopeExpand">
        <el-table :data="expandsStudent" style="width: 100%">
           <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            label="约课编号"
            prop="id">
          </el-table-column>
          <el-table-column
            label="学员姓名"
            prop="stdName">
          </el-table-column>
          <el-table-column
            label="家长姓名"
            prop="parentName">
          </el-table-column>
           <el-table-column
            label="电话"
            prop="telephone">
          </el-table-column>
          <el-table-column
            label="生日"
            prop="stdBrith">
            <template slot-scope="scope">
              {{scope.row.stdBrith.split(' ')[0]}}
            </template>
          </el-table-column>
          <el-table-column
            label="年龄"
            prop="stdBrith">
            <template slot-scope="scope">
              {{scope.row.stdBrith | calcStudentAge}}岁
            </template>
          </el-table-column>
          <el-table-column
            label="课包"
            prop="packageName">
          </el-table-column>
          <el-table-column
            label="取消原因"
            prop="remark">
          </el-table-column>
        </el-table>
      </template>
    </el-table-column>
    <el-table-column
      type="selection"
      width="55">
    </el-table-column>
        <el-table-column
          width="30"
          v-if="idFlag"
          prop="id"
          label="id"
          align="center"
        ></el-table-column>
        <el-table-column prop="courseDate" label="日期" align="left" sortable>
          <template slot-scope="scope">
            <el-icon name="time"></el-icon>
            <span style="margin-left: 10px">{{
              scope.row.courseDate | filterTime
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="courseTime"
          label="课程时间段"
          align="left"
          width="120"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag disable-transitions>{{ scope.row.courseTime }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="classType"
          label="班级类型"
          align="left"
          width="180"
          :filters="this.courseTypeData"
          :filter-method="filterCourseType"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterCourseType(scope.row)"
              disable-transitions
              >{{ scope.row.classType }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="courseLocation"
          label="课程地点"
          align="left"
          width="120"
          :filters="this.courseLocationData"
          :filter-method="filterCourseLocation"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterCourseLocation(scope.row)"
              disable-transitions
              >{{ scope.row.courseLocation }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="coursePeopleCounts"
          label="已约人数"
          align="left"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="studentMax"
          label="学员上限"
          align="left"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="studentMin"
          label="学员下限"
          align="left"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="courseReleaseDate"
          label="发布时间"
          align="left"
          width="180"
          sortable
        >
          <template slot-scope="scope">
            <el-icon name="time"></el-icon>
            <span style="margin-left: 10px">{{
              scope.row.courseReleaseDate
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="courseNote"
          label="学习内容"
          align="center"
          width="420"
        ></el-table-column>
        <el-table-column
          prop="courseDetail"
          label="约课详情"
          align="center"
        >
          <template>
<!--            这是约课详情-->
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <el-dialog title="预约课程" :visible.sync="clockInDialogShow1">
        <el-form ref="appointmentCourseDate" :model="appointmentCourseDate">
          <el-form-item required label="学生姓名" :label-width="formLabelWidth">
            <el-input
              placeholder="请输入学生姓名"
              :rows="2"
              type="text"
              v-model="appointmentCourseDate.studentName"
            ></el-input>
          </el-form-item>
          <el-form-item
            required
            label="会员手机号"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入会员手机号"
              :rows="2"
              type="text"
              @input="searchCourse"
              v-model="appointmentCourseDate.phone"
            ></el-input>
          </el-form-item>
          <el-form-item required label="是否候补" :label-width="formLabelWidth">
            <el-select
              v-model="appointmentCourseDate.isCandidate"
              placeholder="请选择是否候补"
            >
              <el-option
                v-for="item in candidateList"
                :label="item.label"
                :key="item.value"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item required label="课包类型">
            <el-cascader
              v-model="appointmentCourseDate.coursePackageId"
              :options="options"
              collapse-tags
              :show-all-levels="false"
              @change="changeVal"
              clearable
            ></el-cascader>
          </el-form-item> -->
          <el-form-item required label="会员课包" :label-width="formLabelWidth">
            <el-select
              v-model="appointmentCourseDate.coursepackageid"
              placeholder="请选择"
              style="width:300px"
            >
              <el-option
                v-for="item in this.coursePackageAndMemberOption"
                :key="item.id"
                :label="item.coursePackageName ? (item.coursePackageName + ' （剩余课时数：' + item.classHour) + ')': ''"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clockInDialogShow1 = false">取 消</el-button>
          <el-button type="primary" @click="submitStudent()"
            >确 定</el-button
          >
        </div>
      </el-dialog>
        <el-dialog title="取消预约" :visible.sync="clockInDialogShow9">
            <el-form ref="appointmentRecordDate" :model="appointmentRecordDate">
                <el-form-item required label="取消原因" :label-width="formLabelWidth">
                    <el-input
                            placeholder="请输入取消原因"
                            :rows="2"
                            type="text"
                            v-model="appointmentRecordDate.remark"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="clockInDialogShow9 = false">取 消</el-button>
                <el-button type="primary" @click="submitDelRecord()"
                >确 定</el-button
                >
            </div>
        </el-dialog>
    </div>
    <el-dialog title="批量修改发布时间" :visible.sync="editTimeDialogVisible">
      <el-date-picker
            v-model="batchEditDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          ></el-date-picker>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editTimeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitBatchEditTime">确 定</el-button>
      </div>
</el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SearchItem from "./components/searchItem";
import AddFundDialog from "./components/addCourseDialog";
import Pagination from "@/components/pagination";
import { myTime, formatDateTime, formatDateTime1 } from "../../utils/date.js";
import { getFormatCoursePackages } from "@/api/coursepackage";
import { getFormatClassTypes } from "@/api/courseType";
import { getFormatTeachingpoint } from "@/api/teachingpoint";
import {
  getCancelCourseLists,
  deleteUnBeginCourse,
  batchDeleteUnBeginCourse,
  appointmentCourse,
  getCancelCourseByMemberLists,
  deleteRecord,
  getCoursePackageAndMemberByPhone,
  addAppointmentCourseByPhone,
  batchEditCourseDate
} from "@/api/course";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";
import { getFormatCoursePackagesForCourse } from "@/api/coursepackage";
import { getCoursePackageAndMemberByCoursePackageIdAndTelephone } from "@/api/memberCoursePackage";

export default {
  data() {
    return {
      operationRecordData: {
        courseDate: "",
        courseTime: "",
        courseLocation: "",
        courseType: "",
      },
      appointmentCourseDate: {
        telephone: "",
        courseId: "",
        stdName: "",
        isCandidate: "",
        coursePackageAndMemberId: "-1",
        coursePackageId: "",
      },
      appointmentRecordDate: {
        remark: "",
        id: "",
      },
      options: [],
      clockInDialogShow1: false,
      clockInDialogShow9: false,
      tableData: [],
      courseTypeData: [],
      courseLocationData: [],
      coursePackage: [],
      formLabelWidth: "100px",
      tableHeight: 0,
      loading: false,
      idFlag: false,
      isShow: false, // 是否显示资金modal,默认为false
      editid: "",
      multipleSelection: [], //多选的数据
      sortnum: 0,
      format_course_type_list: {},
      format_course_location_list: {},
      addCourseDialog: {
        show: false,
        dialogRow: {},
        courseTypeList: {},
        courseLocationList: {},
        coursePackageList: {},
        formatList: {},
      },
      courseData: {
        page: 1,
        limit: 20,
      },
      pageTotal: 0,
      // 用于列表筛选
      fields: {},
      // 批量修改的时间
      batchEditDate:'',
      editTimeDialogVisible: false,
      //表格展开行
      expands: [],
      courseRow:{},
      coursePackageAndMemberOption: [
        {
          value: "-1",
          label: "该会员没有这种类型的课包",
        },
      ],
            candidateList: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      expandsStudent:[],
      getRowKeys(row) {
         return row.id
      },
    };
  },
  filters: {
    filterTime(time) {
      return formatDateTime(time);
    },
    filterTime1(time) {
      var dd = myTime(time);
      return formatDateTime1(dd);
    },
    calcStudentAge(startDate) {
      var date = new Date();
      startDate = new Date(startDate);
      var newDate = date.getTime() - startDate.getTime();
      // 向下取整  例如 10岁 20天 会计算成 10岁
      // 如果要向上取整 计算成11岁，把floor替换成 ceil
      return Math.floor(newDate / 1000 / 60 / 60 / 24 / 365);
    },
  },
  components: {
    SearchItem,
    AddFundDialog,
    Pagination,
  },
  computed: {
    ...mapGetters(["courseSearch"]),
  },
  mounted() {
    this.getFormatCoursePackagesForCourse();
    this.getFormatTeachingpoint();
    this.getFormatCoursePackages();
    this.getFormatClassTypes();
    this.getUnBeginCourseList();
  },
  methods: {
    onSubmit1(form) {
      let formData = this[form];
      console.log(formData);
      formData.coursePackageId = formData.coursePackageAndMemberId.split(
        "-"
      )[0];
      formData.coursePackageAndMemberId = formData.coursePackageAndMemberId.split(
        "-"
      )[1];
      appointmentCourse(formData).then((res) => {
        console.log(res);
        if (res.data.code === 200) {
          this.clockInDialogShow1 = false;
          const para = {
            userName: getToken("USERNAME"),
            content:
              "后台帮学员:" +
              formData.stdName +
              "预约课程,课程日期为:" +
              this.operationRecordData.courseDate +
              ",课程时间段:" +
              this.operationRecordData.courseTime +
              ",课程地点为:" +
              this.operationRecordData.courseLocation +
              ",课程类型为:" +
              this.operationRecordData.courseType,
          };
          addOperationRecord(para).then((res) => {
            console.log(res);
          });
          this.$message({
            type: "success",
            message: res.data.data[0],
            duration: 3000,
          });
          this.appointmentCourseDate = {
            telephone: "",
            courseId: "",
            stdName: "",
            isCandidate: "",
            coursePackageAndMemberId: "-1",
            coursePackageId: "",
          };
          this.getUnBeginCourseList();
        } else {
          this.$message({
            type: "warning",
            message: res.data.msg,
            duration: 3000,
          });
        }
      });
    },
    changeVal() {
      console.log(this.appointmentCourseDate.telephone);
      // const coursePackageId = val[1];
      // console.log(coursePackageId);
      getCoursePackageAndMemberByCoursePackageIdAndTelephone({
        // coursePackageId: coursePackageId,
        telephone: this.appointmentCourseDate.telephone,
      }).then((res) => {
        console.log(res);
        if (res.data.code === 200) {
          this.appointmentCourseDate.coursePackageAndMemberId = "";
          this.coursePackageAndMemberOption = res.data.data;
        } else {
          this.appointmentCourseDate.coursePackageAndMemberId = "-1";
          this.coursePackageAndMemberOption = [
            {
              value: "-1",
              label: "该会员没有这种类型的课包",
            },
          ];
        }
      });
    },
    getFormatCoursePackagesForCourse() {
      getFormatCoursePackagesForCourse().then((res) => {
        console.log("getFormatCoursePackagesForCourse");
        console.log(res);
        this.options = res.data.data;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection,'test');
    },
    getFormatClassTypes() {
      getFormatClassTypes().then((res) => {
        console.log(res);
        this.courseTypeData = res.data.data.classTypeDataList;
        var courseTypeList = {
          courseTypeList: this.courseTypeData,
        };
        this.addCourseDialog.courseTypeList = courseTypeList;
        this.format_course_type_list = res.data.data.formatClassTypeList;
        this.addCourseDialog.formatList.format_course_type_list = this.format_course_type_list;
      });
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    getFormatCoursePackages() {
      getFormatCoursePackages().then((res) => {
        var coursePackageList = {
          coursePackageList: res.data.data.coursePackageData,
        };
        this.addCourseDialog.coursePackageList = coursePackageList;
      });
    },
    getFormatTeachingpoint() {
      getFormatTeachingpoint().then((res) => {
        this.courseLocationData = res.data.data.courseLocationData;

        var courseLocationList = {
          courseLocationList: this.courseLocationData,
        };
        this.addCourseDialog.courseLocationList = courseLocationList;
        this.format_course_location_list =
          res.data.data.formatCourseLocationList;
        this.addCourseDialog.formatList.format_course_location_list = this.format_course_location_list;
      });
    },
    onAppointmentCourse(row) {
      this.clockInDialogShow1 = true;
      this.courseRow = row
      this.appointmentCourseDate.courseId = row.id;
      this.operationRecordData.courseDate = row.courseDate;
      this.operationRecordData.courseTime = row.courseTime;
      this.operationRecordData.courseLocation = this.format_course_location_list[
        parseInt(row.courseLocation)
      ];
      this.operationRecordData.courseType = this.format_course_type_list[
        parseInt(row.classType)
      ];
      // this.changeVal();
    },
    onAppointmentRecord(row) {
      this.clockInDialogShow9 = true;
      this.courseRow = row
      console.log(row)
    },
    //获取未完课列表数据
    getUnBeginCourseList() {
      const para = Object.assign({}, this.courseData, this.courseSearch);
      console.log(para);
      getCancelCourseLists(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.total;
        this.tableData = res.data.data.courseData;
      });
    },
    // 显示资金弹框
    showAddCourseDialog(val) {
      this.$store.commit("SET_COURSE_DIALOG_TITLE", val);
      this.addCourseDialog.show = true;
    },
    hideAddFundDialog() {
      this.addCourseDialog.show = false;
    },
    // 上下分页
    handleCurrentChange(val) {
      this.courseData.page = val;
      this.getUnBeginCourseList();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.courseData.limit = val;
      this.getUnBeginCourseList();
    },
    /**
     * 格式化状态
     */
    filterCourseType(value, item) {
      console.log(item.classType);
      const type = parseInt(item.classType);
      return (
        this.format_course_type_list[value] ==
        this.format_course_type_list[type]
      );
    },
    filterCourseLocation(value, item) {
      const type = parseInt(item.courseLocation);
      return (
        this.format_course_location_list[value] ==
        this.format_course_location_list[type]
      );
    },
    formatterCourseType(item) {
      const type = parseInt(item.classType);
      return this.format_course_type_list[type];
    },
    formatterCourseLocation(item) {
      const type = parseInt(item.courseLocation);
      return this.format_course_location_list[type];
    },
    // 编辑操作方法
    onEditCourse(row) {
      var courseTime = row.courseTime;
      var courseTimeArray = courseTime.split("-");
      var para = {
        beginTime: courseTimeArray[0],
        endTime: courseTimeArray[1],
      };
      var param = Object.assign({}, row, para);
      console.log(param);
      this.addCourseDialog.dialogRow = {
        param,
      };
      this.showAddCourseDialog();
    },
    // 删除数据
    onDeleteCourse(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const para = { id: row.id };
          let courseDate = row.courseDate;
          let courseTime = row.courseTime;
          let courseLocation = this.format_course_location_list[
            parseInt(row.courseLocation)
          ];
          let courseType = this.format_course_type_list[
            parseInt(row.classType)
          ];
          deleteUnBeginCourse(para).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            const para = {
              userName: getToken("USERNAME"),
              content:
                "删除未开课课程操作，课程日期为:" +
                courseDate +
                ",课程时间段为:" +
                courseTime +
                ",课程地点为:" +
                courseLocation +
                ",课程类型为:" +
                courseType,
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            this.getUnBeginCourseList();
          });
        })
        .catch(() => {});
    },
    onBatchDelMember() {
      this.$confirm("确认批量删除记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const ids = this.multipleSelection.map((item) => item.id).toString();
          const para = { ids: ids };
          batchDeleteUnBeginCourse(para).then((res) => {
            // console.log(res);
            if (res.data.code == 200) {
              this.$message({
                message: "批量删除成功",
                type: "success",
              });
              this.getUnBeginCourseList();
            }
          });
        })
        .catch(() => {});
    },
    onBatchEditPubTime() {
      if(this.multipleSelection.length >= 1) {
        this.editTimeDialogVisible = true
      }
    },
    submitBatchEditTime() {
      if(this.batchEditDate === '') {
         this.$message({
          message: "请选择日期",
          type: "error",
        });
        return
      }
      console.log('批量修改以下数据的发布时间',this.multipleSelection,'发布时间为:',this.batchEditDate);
      batchEditCourseDate({courseReleaseDate: this.batchEditDate,ids: this.multipleSelection.map(item => item.id).join(',')}).then(res => {
        if (res.data.code == 200) {
          this.$message({
            message: "批量修改成功",
            type: "success",
          });
          const para = {
              userName: getToken("USERNAME"),
              content: '未完课列表批量修改发布时间'
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
          this.editTimeDialogVisible = false
          this.getUnBeginCourseList();
        }
      })
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    selectTable(val, row) {
      this.setSearchBtn(val);
    },
    // 用户全选checkbox时触发该事件
    selectAll(val) {
      this.setSearchBtn(val);
    },
    setSearchBtn(val) {
      let isFlag = true;
      if (val.length > 0) {
        isFlag = false;
      } else {
        isFlag = true;
      }
      this.$store.commit("SET_COURSE_SEARCHBTN_DISABLED", isFlag);
    },
    toggleRowData(row, expandedRows) {
      if (expandedRows.length) {
        this.expands = []
        if(row) {
          this.getCourseStudentInfo(row.id)
        }
      } else {
         this.expands = []
      }
    },
    getCourseStudentInfo(id) {
      getCancelCourseByMemberLists({id:id}).then(res => {
        console.log(res.data.data.recordData);
        this.expandsStudent = res.data.data.recordData
        this.expands.push(id)
      })
    },
    submitStudent() {
      this.appointmentCourseDate.courseId = this.courseRow.id
      console.log('上传学生',this.appointmentCourseDate);
      addAppointmentCourseByPhone(this.appointmentCourseDate).then((res) => {
        console.log(res,5145);
        if(res.data.code === 200) {
          this.$message({
            message: '添加成功',
            type: "success",
          });
        }else {
          this.$message({
            message: res.data.data,
            type: "error",
          });
        }
        
        const para = {
          userName: getToken("USERNAME"),
          content:  `增加时间段${this.courseRow.courseDate.split(' ')[0]} ${this.courseRow.courseTime}，学生：${this.appointmentCourseDate.studentName}`
        };
        addOperationRecord(para).then((res) => {
          console.log(res);
        });
        this.clockInDialogShow1 = false
        this.expands = []
        this.currentExpandRow = {}
        this.getUnBeginCourseList();

      });
    },
    // 取消预约
    submitDelRecord() {
      this.appointmentRecordDate.id = this.courseRow.id
      console.log('取消预约',this.appointmentRecordDate);
      deleteRecord(this.appointmentRecordDate).then((res) => {
        console.log(res);
        if(res.data.code === 200) {
          this.$message({
            message: '添加成功',
            type: "success",
          });
        }else {
          this.$message({
            message: res.data.data,
            type: "error",
          });
        }

        const para = {
          userName: getToken("USERNAME"),
          content:  `后台取消预约：预约ID -> ${this.courseRow.id}，学生：${this.courseRow.stdName}`
        };
        addOperationRecord(para).then((res) => {
          console.log(res);
        });
        this.clockInDialogShow9 = false
        this.expands = []
        this.getUnBeginCourseList();

      });
    },
    //删除学生
    onStudentDel(row) {
      console.log('删除学生，当前学生行',row);
      this.$confirm("是否删除该学生?", "提示", {
        type: "warning",
      })
        .then(() => {
          deleteRecord({id: row.id}).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            const para = {
              userName: getToken("USERNAME"),
              content:  `删除${this.currentExpandRow.courseDate.split(' ')[0]}，课程时间段${this.currentExpandRow.courseTime}的学生${row.stdName}`
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            this.expands = []
            this.currentExpandRow = {}
            this.getUnBeginCourseList();
          });
        })
        .catch(() => {});
    },
    //监听手机号
    searchCourse(phone) {
      clearTimeout(this.phoneTimer)
      this.phoneTimer = setTimeout(() => {
        if(phone.length === 11) {
          this.getCourseData(phone)

        }
      }, 400);
    },
    getCourseData(phone) {
      getCoursePackageAndMemberByPhone({phone}).then(res => {
        if(res.data.data.coursePackageAndMemberDatas !== undefined) {
          this.coursePackageAndMemberOption = res.data.data.coursePackageAndMemberDatas
          if(this.coursePackageAndMemberOption.length === 0) {
            this.coursePackageAndMemberOption = [
              {
                value: "-1",
                label: "该会员没有这种类型的课包",
              },
            ]
            this.$message.error('当前会员没有课包')
          }
        }else {
          this.coursePackageAndMemberOption = []
          this.appointmentCourseDate.coursepackageid = ""
          this.$message.error('会员不存在')
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>


